export const assignmentDetailsRoutes = [
  {
    path: ':id',
    name: 'assignment-details',
    component: () => import(/* webpackChunkName: "assignment-details" */ './AssignmentDetails.vue')
  },

  {
    path: 'pdf/:id',
    name: 'assignment-details-pdf',
    component: () =>
      import(/* webpackChunkName: "assignment-details-pdf" */ './AssignmentDetailsPdf.vue')
  }
];
